import React, { useState, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import * as style from 'styles/components/utils/arenaInfo.module.scss';

const ArenaMen = () => {
    // const arenaName = 'Tele2 Arena';
    const refTele2 = useRef();
    const refKlack = useRef();
    const refAktivSittplats = useRef();
    const refSittplats = useRef();
    const refFamilj = useRef();
    const refRullstol = useRef();
    const refKlubbstol = useRef();

    const [activeTab, setActiveTab] = useState(refTele2);

    return (
        <div className={style.arenaInfo}>
            <ul className="tabs wrapper">
                <li key="tele2">
                    <button
                        className={activeTab === refTele2 ? 'active' : ''}
                        type="button"
                        onClick={() => setActiveTab(refTele2)}
                        aria-label="Tele2 Arena"
                    >
                        Tele2 Arena
                    </button>
                </li>
                <li key="klack">
                    <button
                        className={activeTab === refKlack ? 'active' : ''}
                        type="button"
                        onClick={() => setActiveTab(refKlack)}
                        aria-label="Klack"
                    >
                        Klack
                    </button>
                </li>
                <li key="aktivsittplats">
                <button
                        className={activeTab === refAktivSittplats ? 'active' : ''}
                        type="button"
                        onClick={() => setActiveTab(refAktivSittplats)}
                        aria-label="Aktiv Sittplats"
                    >
                        Aktiv sittplats
                    </button>
                </li>
                <li key="sittplats">
                <button
                        className={activeTab === refSittplats ? 'active' : ''}
                        type="button"
                        onClick={() => setActiveTab(refSittplats)}
                        aria-label="Sittplats"
                    >
                        Sittplats
                    </button>
                </li>
                <li key="familjelaktare">
                <button
                        className={activeTab === refFamilj ? 'active' : ''}
                        type="button"
                        onClick={() => setActiveTab(refFamilj)}
                        aria-label="Familjeläktare"
                    >
                        Familjeläktare
                    </button>
                </li>
                <li key="itemLive6">
                <button
                        className={activeTab === refRullstol ? 'active' : ''}
                        type="button"
                        onClick={() => setActiveTab(refRullstol)}
                        aria-label="Rullstol"
                    >
                        Rullstol
                    </button>
                </li>
                <li key="itemLive7">
                <button
                        className={activeTab === refKlubbstol ? 'active' : ''}
                        type="button"
                        onClick={() => setActiveTab(refKlubbstol)}
                        aria-label="Privat Klubbstol"
                    >
                        Privat klubbstol
                    </button>
                </li>
            </ul>
            {activeTab === refTele2 ? (
                <div className={style.arenaInfo__container}>
                    <div className={style.arenaInfo__arenaOverview}>
                        <div className={style.arenaInfo__arenaImage}>
                            <StaticImage
                                src="../../images/takeover/arena-men-overview.png"
                                alt="Översikt Tele2 Arena"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className={style.arenaInfo__arenaInfoContainer}>
                        <div className={style.arenaInfo__background}>
                            <img src="https://www.hammarbyfotboll.se/static/background-about-93a87580ec6143487a9d18031cb4abad.jpg" alt="bakgrundsbild" />
                        </div>
                        <div className={style.arenaInfo__info}>
                            <h3>Tele2 Arena</h3>
                            <h2>Våra läktare på Nya Söderstadion</h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                            </p>

                        </div>
                    </div>
                </div>
            ) : null}

            {activeTab === refKlack ? (
                <div className={style.arenaInfo__container}>
                    <div className={style.arenaInfo__arenaOverview}>
                        <div className={style.arenaInfo__arenaImage}>
                            <StaticImage
                                src="../../images/takeover/arena-men-klack.png"
                                alt="Klack - Tele2 Arena"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className={style.arenaInfo__arenaInfoContainer}>
                        <div className={style.arenaInfo__background}>
                            <img src="https://www.hammarbyfotboll.se/static/background-about-93a87580ec6143487a9d18031cb4abad.jpg" alt="bakgrundsbild" />
                        </div>
                        <div className={style.arenaInfo__info}>
                            <h2>Vår klack</h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                            </p>

                            <ul className={style.arenaInfo__priceList}>
                                <li className={style.arenaInfo__priceListHeader}>
                                    <div className={style.arenaInfo__priceList_title}>
                                        Säsongskort
                                    </div>
                                    <div className={style.arenaInfo__priceList_price}>
                                        Pris
                                    </div>
                                    <div className={style.arenaInfo__priceList_priceReduced}>
                                        Reducerat pris
                                    </div>
                                </li>

                                <li className={style.arenaInfo__priceListRow}>
                                    <div className={style.arenaInfo__priceList_title}>
                                        Klack kortsida
                                    </div>
                                    <div className={style.arenaInfo__priceListPrice}>
                                        2 350 kr
                                    </div>
                                    <div className={style.arenaInfo__priceListPriceReduced}>
                                        1 300-1 600  kr
                                    </div>
                                </li>

                                <li className={style.arenaInfo__priceListRow}>
                                    <div className={style.arenaInfo__priceList_title}>
                                        Klack långsida
                                    </div>
                                    <div className={style.arenaInfo__priceListPrice}>
                                        2 900 kr
                                    </div>
                                    <div className={style.arenaInfo__priceListPriceReduced}>
                                        1 700-2 000  kr
                                    </div>
                                </li>
                            </ul>

                            <a className={style.arenaInfo__columnCta} href="https://hammarbyfotboll.se/biljetter#sasongskort" target="_blank" rel="noreferrer">Förnya säsongskortet till Allsvenskan</a>

                        </div>
                    </div>
                </div>
            ) : null}

        </div>
    );
}
export default ArenaMen;
